
import { Sidebar } from "primereact/sidebar";
import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import UserService from "../../../../GlobalSetupComponents/Services/UserService";
import { roleIdProcurement } from "../../../../GlobalSetupComponents/Enum/RoleEnum";
import { showErrorToast } from "../../../../components/Constant/Notification";

const InputField = ({ label, name, type = "text", value, onChange, required = false, min }) => (
  <div className="grid grid-cols-12 gap-4 items-center mb-4">
  <div className="flex  col-span-4 text-sm font-medium text-gray-700">
    <label className="">{label}</label>
    {required && <span className="text-red-500">*</span>}
  </div>

    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      className="w-full p-2 border col-span-8 rounded-md input-focus"
      required={required}
      min={min}
    />
  </div>
);

const ProspectLayoutUnitForm = ({ unit, onSave, onCancel, propertyId , existingUnits }) => {

  const [sourceBy, setSourceBy] = useState([]);
  const [formData, setFormData] = useState({
    id: unit?.id || null, // Use null for new units, actual ID for existing units
    order: unit?.order || (existingUnits?.length + 1 || 1),
    unitNo: unit?.unitNo || "",
    sqft: unit?.sqft || "",
    ratePerSqft: unit?.ratePerSqft || "",
    northDimension: unit?.northDimension || "",
    eastDimension: unit?.eastDimension || "",
    westDimension: unit?.westDimension || "",
    southDimension: unit?.southDimension || "",
    roadFacing: unit?.roadFacing || unit?.roadFacingSide?.name || "",
    roadWidth: unit?.roadWidth || "",
    preferredLocationCharge: unit?.preferredLocationCharge || "",
    registrationCharge: unit?.registrationCharge || "",
    notes: unit?.notes || "",
    unitStatus: unit?.unitStatus?.name || "Available",
    propertyId: unit?.propertyId || propertyId || "",
    vendorGuideline: unit?.vendorGuideline || "",
    governmentGuideline: unit?.governmentGuideline || "",
    isLocallyCreated: unit?.isLocallyCreated || false, // Track if this is a locally created unit
  });

  // Update form data when unit prop changes
  React.useEffect(() => {
    if (unit) {
      setFormData({
        id: unit?.id || null,
        order: unit?.order || (existingUnits?.length + 1 || 1),
        unitNo: unit?.unitNo || "",
        sqft: unit?.sqft || "",
        ratePerSqft: unit?.ratePerSqft || "",
        northDimension: unit?.northDimension || "",
        eastDimension: unit?.eastDimension || "",
        westDimension: unit?.westDimension || "",
        southDimension: unit?.southDimension || "",
        roadFacing: unit?.roadFacing || unit?.roadFacingSide?.name || "",
        roadWidth: unit?.roadWidth || "",
        preferredLocationCharge: unit?.preferredLocationCharge || "",
        registrationCharge: unit?.registrationCharge || "",
        notes: unit?.notes || "",
        unitStatus: unit?.unitStatus?.name || "Available",
        propertyId: unit?.propertyId || propertyId || "",
        vendorGuideline: unit?.vendorGuideline || "",
        governmentGuideline: unit?.governmentGuideline || "",
        isLocallyCreated: unit?.isLocallyCreated || false,
      });
    }
  }, [unit, existingUnits, propertyId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.unitNo.trim()) {
          showErrorToast("Unit No. is required.");
          return;
        }

    // Check if we're editing an existing unit
    const isEditingExistingUnit = unit?.id || unit?.localId;

    const parsedData = {
      ...formData,
      id: formData.id || null, // Ensure null for new units
      sqft: parseFloat(formData.sqft) || 0,
      ratePerSqft: parseFloat(formData.ratePerSqft) || 0,
      northDimension: String(formData.northDimension || ""),
      eastDimension: String(formData.eastDimension || ""),
      westDimension: String(formData.westDimension || ""),
      southDimension: String(formData.southDimension || ""),
      roadWidth: String(formData.roadWidth || ""),
      preferredLocationCharge: parseFloat(formData.preferredLocationCharge) || 0,
      registrationCharge: parseFloat(formData.registrationCharge) || 0,
      vendorGuideline: parseFloat(formData.vendorGuideline) || 0,
      governmentGuideline: parseFloat(formData.governmentGuideline) || 0,
      roadFacingSide: { id: "", name: formData.roadFacing },
      unitStatus: { id: "", name: formData.unitStatus },
      order: parseInt(formData.order) || 1,
      // For new units that haven't been saved to the server yet
      isLocallyCreated: !formData.id,
      // Preserve existing localId for locally created units or generate one for new units
      localId: unit?.localId || (!isEditingExistingUnit ? `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}` : undefined),
      // Preserve original identification for editing
      originalId: unit?.originalId || unit?.id,
      originalLocalId: unit?.originalLocalId || unit?.localId,
      // Flag to indicate this is an edit operation
      isEditing: isEditingExistingUnit,
    };

    onSave(parsedData);
  };


  return (
    <Sidebar
      visible={true}
      position="right"
      onHide={onCancel}
      style={{ width: "560px" }}
      header={
        <div className="flex items-center justify-between w-full">
          <span className="font-semibold text-lg text-customGreen">
            {(unit?.id || unit?.localId) ? "Edit Unit" : "Add Unit"} Info Details
            {/* {unit?.isLocallyCreated && (
              <span className="ml-2 inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800">
                Local Draft
              </span>
            )} */}
          </span>
        </div>
      }
    >
      <form onSubmit={handleSubmit} className="space-y-4 p-4">

        <div>
          
           <InputField 
          label="Unit No." 
          name="unitNo" 
          value={formData.unitNo} 
          onChange={handleChange} 
          required={true}
        />

        </div>
        
       
        <InputField 
          label="Square Feet" 
          name="sqft" 
          type="number" 
          value={formData.sqft} 
          onChange={handleChange} 
        
          min="0" 
        />
        <InputField 
          label="Rate Per Sq.Ft" 
          name="ratePerSqft" 
          type="number" 
          value={formData.ratePerSqft} 
          onChange={handleChange} 
         
          min="0" 
        />
        <div className="grid grid-cols-12 mb-4">
          <label className="col-span-4 text-sm font-medium text-gray-700 mt-2">
            Dimension <span className="text-xs text-customGreen">(In Feet)</span>
          </label>
          <div className="col-span-8">
            <div className="relative w-full h-72 bg-gray-50 rounded-md border flex items-center justify-center p-4">
              <div className="w-40 h-40 border-4 rounded-md border-customGreen flex flex-col justify-between items-center">
                {/* North Side Input */}
                <input
                  type="text"
                  value={formData.northDimension}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length <= 10) {
                      handleChange({ target: { name: "northDimension", value } });
                    }
                  }}
                  className="absolute top-9 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-md px-2 py-1 text-sm text-center w-16 bg-white focus:ring-customGreen focus:border-customGreen border"
                  placeholder="FT"
                  maxLength={10}
                />
                {/* South Side Input */}
                <input
                  type="text"
                  value={formData.southDimension}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length <= 10) {
                      handleChange({ target: { name: "southDimension", value } });
                    }
                  }}
                  className="absolute bottom-9 left-1/2 transform -translate-x-1/2 translate-y-1/2 rounded-md px-2 py-1 text-sm text-center w-16 bg-white focus:ring-customGreen focus:border-customGreen border"
                  placeholder="FT"
                  maxLength={10}
                />
                {/* West Side Input */}
                <input
                  type="text"
                  value={formData.westDimension}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length <= 10) {
                      handleChange({ target: { name: "westDimension", value } });
                    }
                  }}
                  className="absolute left-9 top-1/2 transform -translate-y-1/2 -translate-x-1/2 rounded-md px-2 py-1 text-sm text-center w-16 bg-white focus:ring-customGreen focus:border-customGreen border"
                  placeholder="FT"
                  maxLength={10}
                />
                {/* East Side Input */}
                <input
                  type="text"
                  value={formData.eastDimension}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length <= 10) {
                      handleChange({ target: { name: "eastDimension", value } });
                    }
                  }}
                  className="absolute right-9 top-1/2 transform -translate-y-1/2 translate-x-1/2 rounded-md px-2 py-1 text-sm text-center w-16 bg-white focus:ring-customGreen focus:border-customGreen border"
                  placeholder="FT"
                  maxLength={10}
                />
                {/* Labels inside the plot */}
                <div className="text-xs font-medium text-gray-700 mt-2">North</div>
                <div className="flex justify-between w-full px-4">
                  <div className="text-xs font-medium text-gray-700">West</div>
                  <div className="text-xs font-medium text-gray-700">East</div>
                </div>
                <div className="text-xs font-medium text-gray-700 mb-2">South</div>
              </div>
            </div>
          </div>
        </div>
        <InputField 
          label="Road Facing" 
          name="roadFacing" 
          value={formData.roadFacing} 
          onChange={handleChange} 
        />
        <InputField 
          label="Road Width" 
          name="roadWidth" 
          value={formData.roadWidth} 
          onChange={handleChange} 
        />
        <InputField 
          label="Preferred Location Charge" 
          name="preferredLocationCharge" 
          type="number" 
          value={formData.preferredLocationCharge} 
          onChange={handleChange} 
          min="0" 
        />
        <InputField 
          label="Registration Charge" 
          name="registrationCharge" 
          type="number" 
          value={formData.registrationCharge} 
          onChange={handleChange} 
          min="0" 
        />
        <InputField 
          label="Vendor Guideline" 
          name="vendorGuideline" 
          type="number" 
          value={formData.vendorGuideline} 
          onChange={handleChange} 
          min="0" 
        />
        <InputField 
          label="Government Guideline" 
          name="governmentGuideline" 
          type="number" 
          value={formData.governmentGuideline} 
          onChange={handleChange} 
          min="0" 
        />
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">Notes</label>
          <textarea
            name="notes"
            value={formData.notes}
            onChange={handleChange}
            className="w-full p-2 border rounded-md focus:ring-customGreen focus:border-customGreen"
            rows="4"
          />
        </div>
        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 bg-customGreen text-white rounded-md hover:bg-green-600"
          >
            {(unit?.id || unit?.localId) ? "Update" : "Save"}
          </button>
        </div>
      </form>
    </Sidebar>
  );
};

export default ProspectLayoutUnitForm;